import { css } from 'styled-components';
import { darken10, handleLightOrDark, lighten10 } from '../colors';
// TODO replace with ramda
function always(arg: string) {
	return arg;
}

const textColor = (input: string, lightText: string, darkText: string) =>
	handleLightOrDark(
		input,
		() => always(darkText),
		() => always(lightText)
	);

const hoverColor = (input: string) =>
	handleLightOrDark(input, darken10, lighten10);

export const buttonBackgroundAndColorDecorator = (input?: string) => {
	const background = input || '#851bb7';
	const color = textColor(background, '#fffffa', '#00000f');
	return css`
		background: ${background};
		color: ${color};
		:hover {
			background: ${hoverColor(background)};
		}
	`;
};
